export default __webpack_public_path__ + "static/media/AE5.07097c50.jpg";